import { createLoaderImp } from '../../../components/ozmoit/common/loader-imp';
import { getFormDetailsAction } from '../actions';

const {
  useLoaderData: useWarningsSummaryDetailsFormLoaderData,
  LoaderConsumerSimple,
  LoaderProvider,
} = createLoaderImp({
  action: getFormDetailsAction,
});

function StudentWarningsSummaryDetailsFormLoader({
  children,
  ...props
}: Parameters<typeof LoaderProvider>[0]) {
  return (
    <LoaderProvider {...props}>
      <LoaderConsumerSimple>{children}</LoaderConsumerSimple>
    </LoaderProvider>
  );
}

export {
  StudentWarningsSummaryDetailsFormLoader,
  useWarningsSummaryDetailsFormLoaderData,
};
